import React from 'react';

// components
import TextInputBox from '../../../components/elements/forms/TextInputBox';
import MiniButton from '../../../components/elements/forms/MiniButton';

// state and service
import { update_professional_summary } from '../../../service/api/report_role';
import { IRoleCandidateUpdate } from '../../../store/types/report_role';
import { useAppDispatch } from '../../../store/hooks';

type IUpdateProfessionalSummary = {
	id: string;
	onRefresh: () => void;
	professional: string;
};

const UpdateProfessionalSummary: React.FC<IUpdateProfessionalSummary> = ({
	id,
	professional,
	onRefresh
}) => {
	const dispatch = useAppDispatch();
	const [show, showSet] = React.useState<boolean>(false);
	const [data, dataSet] = React.useState<IRoleCandidateUpdate>({
		id: '',
		name: ''
	});

	const onLoad = React.useCallback(() => {
		if (id)
			dataSet((prev) => ({ ...prev, id: id.toString(), name: professional }));
	}, [id, professional]);

	React.useEffect(() => {
		onLoad();
	}, [onLoad]);
	return (
		<div>
			{!show ? (
				<div>{data.name}</div>
			) : (
				<TextInputBox
					name="name"
					placeholder="Add Professional Summary"
					value={data.name}
					onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
						dataSet((prev) => ({ ...prev, name: e.target.value }))
					}
				/>
			)}
			<div className="w-full flex justify-end my-2">
				<div className="w-[15%]">
					<MiniButton
						title="Update"
						onHandler={() => {
							if (show) {
								// update new data
								update_professional_summary(dispatch, data);
								setTimeout(() => onRefresh(), 400);
								showSet(false);
							} else {
								showSet(true);
							}
						}}
						backgroundColor="#CDD8FE"
						textColor="#243677"
					/>
				</div>
			</div>
		</div>
	);
};

export default UpdateProfessionalSummary;
